// extracted by mini-css-extract-plugin
export default {"container":"Vaults_container__-KAYy","vaults":"Vaults_vaults__3gUeu"};